import React, { useId } from 'react';
import { Form } from 'react-bootstrap';
import type { LayerDef } from 'hooks/Meteorology/Agro/Maps/useAgroMapState';
import './index.scss';

export default function AgroMapLayersPanel({
  layers,
  onToggle,
  definitions,
}: {
  layers: Record<string, boolean>;
  onToggle: (key: string) => () => void;
  definitions: LayerDef[];
}) {
  const uid = useId();

  return (
    <div className="agro-map-overlay agro-map-overlay-layers">
      <div className="agro-overlay-title">CAMADAS</div>
      {definitions.map(({ key, label }) => (
        <Form.Check
          key={key}
          type="switch"
          id={`${uid}-${key}`}
          label={label}
          checked={layers[key] ?? true}
          onChange={onToggle(key)}
        />
      ))}
    </div>
  );
}
